import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Table, Loader, Icon} from 'semantic-ui-react';
import {returnsStatus} from '../../../common/dictionaries/parameters';
import {shortDate} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';

class RecordsSection extends Component {
  handleEditClick(selectedOrder) {
    this.props.selectPartReturnOrder(selectedOrder);
    this.props.navigateTo(paths.PartsReturnsDetail);
  }

  renderIcon(returnOrder) {
    if (['X'].includes(returnOrder.status)) {
      return null;
    }

    const iconName = returnOrder.status === 'C' ? 'eye' : 'write';

    return (
      <Icon link
        size='large'
        color='blue'
        name={iconName}
        onClick={() => this.handleEditClick(returnOrder)}
      />
    );
  }

  renderContent() {
    const {loading, list} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered'>Consultando...</Loader>
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>No se encontraron registros.</Table.Cell>
        </Table.Row>
      );
    }

    return list.map((returnOrder) => {
      return (
        <Table.Row key={returnOrder.code} textAlign='center'>
          <Table.Cell>{moment(returnOrder.date).format(shortDate)}</Table.Cell>
          <Table.Cell>{returnOrder.orderNumber}</Table.Cell>
          <Table.Cell>{returnOrder.dealer}</Table.Cell>
          <Table.Cell>{returnOrder.agency}</Table.Cell>
          <Table.Cell>{returnOrder.contactName}</Table.Cell>
          <Table.Cell>{returnsStatus[returnOrder.status]}</Table.Cell>
          <Table.Cell>{this.renderIcon(returnOrder)}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <Card raised fluid className='content-section'>
        <div className='scroll-table'>
          <Table striped>
            <Table.Header>
              <Table.Row textAlign='center'>
                <Table.HeaderCell>Fecha</Table.HeaderCell>
                <Table.HeaderCell>No. Orden</Table.HeaderCell>
                <Table.HeaderCell>Concesionario</Table.HeaderCell>
                <Table.HeaderCell>Agencia</Table.HeaderCell>
                <Table.HeaderCell>Contacto</Table.HeaderCell>
                <Table.HeaderCell>Estado</Table.HeaderCell>
                <Table.HeaderCell>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderContent()}
            </Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partsReturnsOrders.loading,
    'list': state.partsReturnsOrders.list,
  };
};

const {
  navigateTo,
  selectPartReturnOrder,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  selectPartReturnOrder,
})(RecordsSection);
